module.exports = "<div ng-if=\"ctrl.pageNotFound\" class=\"{{ctrl.baseContainerClass}}\">\r\n  <br/>\r\n  <div class=\"alert alert-dismissible alert-warning\">\r\n    <i class=\"fa fa-fw fa-4x fa-meh-o\" style=\"float:left\"></i>\r\n    <h4>Oops! Page Not Found</h4>\r\n    <p>The page you are looking for is not (longer) available.</p>\r\n  </div>\r\n</div>\r\n\r\n<div ng-hide=\"ctrl.pageNotFound\" bind-dynamic-page=\"ctrl.html\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/app/dynamic-pages/view/dynamic-page.html
// module id = 883
// module chunks = 0